import Cookies from "js-cookie";
import * as types from "../mutation-types";

const locales = ["en", "vi", "ja"];

// state
export const state = {
  locale: Cookies.get("ecs_user_locale") || "en",
  locales: locales
};

// getters
export const getters = {
  locale: state => state.locale,
  locales: state => state.locales
};

// mutations
export const mutations = {
  [types.SET_LOCALE](state, { locale }) {
    state.locale = locale;
  }
};

// actions
export const actions = {
  setLocale({ commit }, { locale }) {
    commit(types.SET_LOCALE, { locale });

    Cookies.set("ecs_user_locale", locale, { expires: 365 });
  }
};
